import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetReferencesDocument,
  type GetReferencesQuery,
  type GetReferencesQueryVariables,
} from "~/features/references/gqls";
import { useTenant } from "~/features/tenant/context";

/** All references for the current tenant (ordered by seq; filtered client-side, V1 parity). */
export function useReferenceList() {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetReferencesQuery, GetReferencesQueryVariables>(GetReferencesDocument, {
    variables: { tenantId },
  });
}
